<template>
    <form-row title="Attorney">
        <div class="flex-1 -mt-2">
            <contact-selector
                name_prefix="contacts[buyer_attorney]"
                :available_contacts="available_contacts"
                contact_type="buyer_attorney"
                :value="{
                    contact_id: contact.contact_id,
                    name: contact.name,
                    email: contact.email,
                    phone: contact.phone,
                }"
                :read_only="read_only"
            />

            <div class="mt-3">
                <input-text
                    label="Address"
                    name="contacts[buyer_attorney][address_1]"
                    :value="contact.address_1"
                    placeholder="Address"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    name="contacts[buyer_attorney][address_2]"
                    :value="contact.address_2"
                    placeholder="Address 2"
                    :read_only="read_only"
                />
            </div>

            <div class="flex flex-col sm:flex-row sm:mt-3">
                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_attorney][city]"
                        :value="contact.city"
                        placeholder="City"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-select-states
                        name="contacts[buyer_attorney][state]"
                        no_selection="Select State"
                        :value="contact.state"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_attorney][zip]"
                        :value="contact.zip"
                        placeholder="Zip"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import ContactSelector from '../../components/contact-selector.vue';

export default {
    components: {
        ContactSelector,
    },

    props: {
        contact: { default: () => ({}) },
        available_contacts: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
